import React, { useEffect, useState } from "react";
import { Oval } from "../../assets/imagesPath";
import { useForm } from "react-hook-form";
import Dropdown from "../../assets/icons/Dropdown";
import { useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";
import { useDispatch, useSelector } from "react-redux";
import { updateBusinessForm } from "../../redux/AuthSlice";
import Select from "react-select";

const ServicesNeeded = () => {

  const [ein, setEin] = useState("");
  const [bankAcc, setBankAcc] = useState("");
  const [payroll, setPayroll] = useState("");
  const [emp, setEmp] = useState("");
  const [enableTabs, setEnableTabs] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((data) => data?.auth);
  const formData = auth?.businessDetailForm;
  const [selectedServices, setSelectedServices] = useState(formData?.servicesNeeded?.services || []);

  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "white",
      border: "1px solid #ddd",
      borderRadius: "10px",
      padding: "5px",
      fontSize: "1.2rem",
      cursor: "pointer",

    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#173363",
      borderRadius: "4px",
    }),
    menuList: (provided) => ({ ...provided, paddingTop: 0, paddingBottom: 0, }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "white" : "#173363",
      color: state.isFocused ? "#173363" : "white",
      cursor: "pointer",
      fontSize: "1.2rem",
      // padding: "8px",
      borderRadius: "4px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    singleValue: (base) => ({
      ...base,
      color: "black",
      fontSize: "1.6rem",
    }),
  };


  const options3 = [
    { value: '', label: 'Select' },
    { value: 'YES', label: 'Yes' },
    { value: 'NO', label: 'No' },
    { value: 'NOT_SURE', label: 'I dont know' },
  ];

  const suboptions = [
    { value: '', label: 'Select' },
    { value: '1', label: '1' },
    { value: '2-5', label: '2-5' },
  ];



  const {
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = () => {

    const data = {
      servicesNeeded: {
        services: selectedServices,
        needsEIN: ein,
        needsBankAccount: bankAcc,
        needsPayroll: payroll,
        payrollEmployees: emp
      },
    };

    dispatch(updateBusinessForm(data));
    navigate(PATHS.clientScreening);
  };

  const validationHandler = () => {
    let noError = false;

    bStructureValidationHandler();
    einValidationHandler();
    bankAccValidationHandler();
    payrollValidationHandler();

    if (selectedServices?.length && ein && bankAcc && payroll) {
      onSubmit();
      setEnableTabs(true);
    } else {
      return false;
    }

    return noError;
  };

  const bStructureValidationHandler = () => {
    if (!selectedServices?.length) {
      setError("bStructure", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("bStructure");
    }
  };

  const einValidationHandler = () => {
    if (!ein) {
      setError("ein", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("ein");
    }
  };

  const bankAccValidationHandler = () => {
    if (!bankAcc) {
      setError("bankAcc", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("bankAcc");
    }
  };

  const payrollValidationHandler = () => {
    if (!payroll) {
      setError("payroll", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("payroll");
    }
  };

  const checkboxItems = [
    { id: "default-checkbox", label: "Help forming an LLC" },
    { id: "default-checkbox1", label: "Help forming an S Corporation" },
    { id: "default-checkbox2", label: "Bookkeeping" },
    { id: "default-checkbox3", label: "Cash Basis Financial Statements" },
    { id: "default-checkbox4", label: "Payroll Setup" },
    { id: "default-checkbox5", label: "Tax Planning" },
    { id: "default-checkbox6", label: "Bank Account Setup" },
    { id: "default-checkbox7", label: "Compliance Assistance" },
  ];

  const handleCheckboxChange = (label) => {
    setSelectedServices((prev) => {
      if (prev.includes(label)) {
        return prev.filter((service) => service !== label);
      } else {
        return [...prev, label];
      }
    });
  };

  useEffect(() => {
    if (formData?.servicesNeeded) {
      let { services, needsEIN, needsBankAccount, needsPayroll, payrollEmployees } = formData?.servicesNeeded;
      setSelectedServices(services);
      setEin(needsEIN);
      setBankAcc(needsBankAccount);
      setPayroll(needsPayroll);
      setEmp(payrollEmployees);
    }
  }, [formData?.servicesNeeded]);

  useEffect(() => {
    if (selectedServices?.length) clearErrors("bStructure");
    if (ein) clearErrors("ein");
    if (bankAcc) clearErrors("bankAcc");
    if (payroll) clearErrors("payroll");
  }, [selectedServices?.length, ein, payroll, bankAcc, clearErrors]);

  return (
    <div className="w-full mb-16">

      <div className="mx-auto text-center mb-10 space-x-4 space-y-4 mt-40 tabsBtn">
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.basicInfo)}
        >
          Basic Infomation
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessDetails)}
        >
          Business Details
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#173363] text-[#FFFFFF] border border-[#8188918C]"
          onClick={() => navigate(PATHS.servicesNeeded)}
        >
          Services Needed
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.clientScreening)}
          disabled={!enableTabs}
        >
          Client Screening Questions
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessFormation)}
          disabled={!enableTabs}
        >
          Business Formation Decision
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.additionalDetails)}
          disabled={!enableTabs}
        >
          Additional Details
        </button>
      </div>

      <div className="flex justify-center items-center p-16 pb-40 min-h-[50vh]">
        <div className="w-3/4 smallScreens:w-full bg-white mt-20 shadow-2xl rounded-xl p-10 md:p-20 relative">
          {/* <div className="text-[2.4rem] text-[#121212] text-center mb-20 font-extrabold">Services Needed</div> */}
          <div className="space-y-12">
            <div className='mt-10'>
              <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1rem]">
                Select all you need help with
              </label>
              {/* <div className='relative mt-4'>
                <select
                  className='appearance-none w-full py-5 px-5 border rounded-xl focus:outline-none text-2xl font-normal text-[#757575]'
                >
                  <option value="">Select</option>
                </select>
              </div> */}
            </div>

            <div className="grid grid-cols-2">
              {checkboxItems?.map((item) => (
                <div key={item.id} className="flex items-center mb-4">
                  <div className="mt-3">
                    <input
                      id={item.id}
                      type="checkbox"
                      checked={selectedServices.includes(item.label)}
                      onChange={() => handleCheckboxChange(item.label)}
                      className=" bg-white border-[#9CA3AF] rounded-sm custom-checkbox"
                    />
                  </div>
                  <label
                    htmlFor={item.id}
                    className="ms-6 text-[1.6rem] font-medium text-[#9CA3AF] smallScreens:text-[1rem]"
                  >
                    {item.label}
                  </label>
                </div>
              ))}
            </div>
            {errors.bStructure && (
              <p className="text-red-500 text-[1.2rem] mt-1">
                {errors.bStructure.message}
              </p>
            )}

            <div className="grid grid-cols-2 gap-8 mt-10">
              <div>
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1rem]">
                  Do you need assistance obtaining an EIN?
                </label>
                <div className="relative mt-4">
                  <Select
                    options={options3}
                    value={options3?.find((option) => option.value === ein)}
                    onChange={(selectedOption) => setEin(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />

                </div>
                {errors.ein && (
                  <p className="text-red-500 text-[1.2rem] mt-1">{errors.ein.message}</p>
                )}
              </div>

              <div>
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[0.9rem] mediumScreens:text-[1rem]">
                  Do You Need Help Opening A Business Bank Account?
                </label>
                <div className="relative mt-4">

                  <Select
                    options={options3}
                    value={options3?.find((option) => option.value === bankAcc)}
                    onChange={(selectedOption) => setBankAcc(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />

                </div>
                {errors.bankAcc && (
                  <p className="text-red-500 text-[1.2rem] mt-1">{errors.bankAcc.message}</p>
                )}
              </div>
            </div>


            <div className='mt-10'>
              <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1rem]">
                Do You Need Help With Payroll?
              </label>
              <div className='relative mt-4'>
                <Select
                  options={options3}
                  value={options3?.find((option) => option.value === payroll)}
                  onChange={(selectedOption) => setPayroll(selectedOption.value)}
                  placeholder="Select"
                  styles={customStyles}
                  className="fix_height_input"
                />

              </div>
              {errors.payroll && (
                <p className="text-red-500 text-[1.2rem] mt-1">
                  {errors.payroll.message}
                </p>
              )}
            </div>

            {payroll == "YES" ?
              <div className='mt-10'>
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1rem]">
                  How many employees do you expect to have on payroll annually on average?
                </label>
                <div className='relative mt-4'>
                  <Select
                    options={suboptions}
                    value={suboptions?.find((option) => option.value === emp)}
                    onChange={(selectedOption) => setEmp(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />

                </div>
                {errors.payroll && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.payroll.message}
                  </p>
                )}
              </div>
              : null}

            <div className="text-center">
              <button
                type="button"
                className="w-2/3 text-[1.6rem] bg-[#173363] text-white py-4 rounded-lg"
                onClick={validationHandler}
              >
                Save
              </button>
            </div>
          </div>
          <div className="absolute -top-20 -right-20 h-[10rem] w-[10rem] z-[-1]">
            <img src={Oval} alt="oval-img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesNeeded;